/* unplugin-vue-components disabled */import script from "./HafuView.vue?vue&type=script&setup=true&lang=js"
export * from "./HafuView.vue?vue&type=script&setup=true&lang=js"

import "./HafuView.vue?vue&type=style&index=0&id=02e1c652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e1c652"]])

export default __exports__